import React, { useState } from 'react';
import Slider from 'react-slick';
const ViewMore = dynamic(() => import('../../components/ViewMore'));

import 'slick-carousel/slick/slick.css';
import dynamic from 'next/dynamic';
const GetOrderProposal = dynamic(() => import('../../components/proposal/ppc/OrderNow'));

const PPCManagementSLider = props => {
  const [service, setService] = useState('PPC management services');
  const [showOrderModel, setShowOrderModel] = useState(false);

  const SampleNextArrow = props => {
    const { className, style, onClick } = props;
    return (
      <div className="cursor-pointer absolute" style={{ top: '50%', right: '-30px', transform: 'translateY(-50%)' }} onClick={onClick}>
        <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
      </div>
    );
  };

  const SamplePrevArrow = props => {
    const { className, style, onClick } = props;
    return (
      <div className="cursor-pointer absolute -left-30" style={{ top: '50%', transform: 'translateY(-50%) scaleX(-1)' }} onClick={onClick}>
        <img src="/images/icons/navbar-arrow.svg" alt="navbar-arrow" />
      </div>
    );
  };
  const hideOrderModal = () => {
    setShowOrderModel(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflow = 'auto';
  };
  var settings = {
    infinite: true,
    speed: 300,
    swipe: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: true,
    dotsClass: 'custom-dots',
    waitForAnimate: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          swipe: true,
          arrows: true,
        },
      },
    ],
  };
  return (
    <>
      <style jsx global>{`
        .custom-dots {
          display: flex !important;
          justify-content: center;
          margin-top: 30px;
        }
        .custom-dots li {
          position: relative;
          margin: 0 3px;
          width: 50px;
          height: 3px;
          background-color: #c4c4c4;
          overflow: hidden;
        }
        .custom-dots li.slick-active {
          background-color: #670f7a;
        }
        .custom-dots li button {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          opacity: 0;
          //display:none;
        }
      `}</style>
      <Slider {...settings} className="relative z-10 mt-20 m-15 mt:m-0">
        {props.slides.map((slide, i) => {
          return (
            <div key={'key' + i}>
              <div className="flex flex-wrap-reverse">
                <div className="w-full md:w-40p">
                  <img className="mx-auto md:mx-0" src={'https://admin.weprodigi.com/' + slide.main_image} />
                </div>
                <div className="w-full md:w-60p">
                  <img
                    className="float-left ml-0 md:ml-30 pr-15 pb-0"
                    width={150}
                    src={'https://admin.weprodigi.com/' + slide.logo}
                    alt={slide.logo}
                  />
                  <div className={'hidden md:block pl-30'}>{slide.description}</div>
                  <div className="block md:hidden ">
                    <ViewMore ln={60}>{slide.description}</ViewMore>
                  </div>
                  <div className="flex flex-wrap justify-between md:justify-between mt-15 pl-0 md:pl-15">
                    {slide.leads && (
                      <div className="flex ml-5 md:ml-10 justify-start items-center w-half-auto md:w-auto">
                        <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/click.svg" width={13} height={15} alt="click" />
                        {/*<div  className="ml-10 mt-2 text-16 font-bolder">{slide.ctr}% CTR</div>*/}
                        <div className="ml-10 mt-2 text-16 font-bolder">{slide.leads} Clicks</div>
                      </div>
                    )}

                    {/*<div className="flex ml-5 md:ml-10 justify-start items-center w-half-auto md:w-auto">*/}
                    {/*    <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/click.svg" width={13} height={15}/>*/}
                    {/*    /!*<div  className="ml-10 mt-2 text-16 font-bolder">{slide.ctr}% CTR</div>*!/*/}
                    {/*    <div  className="ml-10 mt-2 text-16 font-bolder">10300 Clicks</div>*/}
                    {/*</div>*/}
                    {/*<div className="flex ml-5 md:ml-10 justify-start items-center w-half-auto md:w-auto">*/}
                    {/*    <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/conversion.svg" width={13} height={15}/>*/}
                    {/*    /!*<div  className="ml-10 mt-2 text-16 font-bolder">{slide.conversion} Conversion</div>*!/*/}
                    {/*    <div  className="ml-10 mt-2 text-16 font-bolder">4750  Conversion</div>*/}
                    {/*</div>*/}
                    {slide.conversion && (
                      <div className="flex ml-5 md:ml-10 justify-start items-center w-half-auto md:w-auto">
                        <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/conversion.svg" width={13} height={15} alt="conversion" />
                        {/*<div  className="ml-10 mt-2 text-16 font-bolder">{slide.conversion} Conversion</div>*/}
                        <div className="ml-10 mt-2 text-16 font-bolder">{slide.conversion} Conversion</div>
                      </div>
                    )}
                    {slide.cr && (
                      <div className="flex ml-5 md:ml-10 justify-start items-center w-half-auto md:w-auto">
                        <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/cr.svg" width={13} height={15} alt="cr" />
                        {/*<div  className="ml-10 mt-2 text-16 font-bolder">{slide.cr}% CR</div>*/}
                        <div className="ml-10 mt-2 text-16 font-bolder">{slide.cr}% CR</div>
                      </div>
                    )}
                    {slide.roars && (
                      <div className="flex ml-5 md:ml-10 justify-start items-center w-half-auto md:w-auto">
                        <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/roas.svg" width={13} height={15} alt="roas" />
                        {/*<div  className="ml-10 mt-2 text-16 font-bolder">{slide.roars}% ROARS</div>*/}
                        <div className="ml-10 mt-2 text-16 font-bolder">{slide.roars}% ROAS</div>
                      </div>
                    )}
                    {/*<div className="flex ml-5 md:ml-10 justify-start items-center w-half-auto md:w-auto">*/}
                    {/*    <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/cr.svg" width={13} height={15}/>*/}
                    {/*    /!*<div  className="ml-10 mt-2 text-16 font-bolder">{slide.cr}% CR</div>*!/*/}
                    {/*    <div  className="ml-10 mt-2 text-16 font-bolder">25.2% CR</div>*/}
                    {/*</div>*/}

                    {/*<div className="flex ml-5 md:ml-10 justify-start items-center w-half-auto md:w-auto">*/}
                    {/*    <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/roas.svg" width={13} height={15}/>*/}
                    {/*    /!*<div  className="ml-10 mt-2 text-16 font-bolder">{slide.roars}% ROARS</div>*!/*/}
                    {/*    <div  className="ml-10 mt-2 text-16 font-bolder">1200% ROAS</div>*/}
                    {/*</div>*/}

                    {slide.ctr && (
                      <div className="flex ml-5 md:ml-10 justify-start items-center w-half-auto md:w-auto">
                        <img src="https://admin.weprodigi.com/uploads/files/shares/ppc/click.svg" width={13} height={15} alt="click" />
                        <div className="ml-10 mt-2 text-16 font-bolder">{slide.ctr}% CTR</div>
                      </div>
                    )}
                  </div>
                  <div className="justify-end hidden md:flex">
                    <a
                      href={slide.case_url}
                      className="mt-25 bg-purple hover:bg-green text-14 md:text-16 text-white flex items-center py-8 px-23 rounded-5 cursor-pointer"
                    >
                      More Cases
                    </a>
                    <a
                      target="_blank"
                      className="md:flex cursor-pointer mt-25 bg-green hover:bg-purple text-16 md:text-16 text-white ml-15 flex items-center py-5  px-23 rounded-5"
                      onClick={() => {
                        setShowOrderModel(true);
                        document.documentElement.style.overflow = 'hidden';
                      }}
                    >
                      Request a Proposal
                    </a>
                    <a
                      target="_blank"
                      className="flex md:hidden cursor-pointer mt-25 bg-green hover:bg-purple text-16 md:text-16 text-white ml-15 items-center py-5 px-23 rounded-5"
                      href={'/paid-advertising-services/order-now?service=' + service}
                    >
                      Request a Proposal
                    </a>
                  </div>
                </div>
              </div>
              <div className="justify-center block md:hidden">
                <a
                  href={'https://weprodigi.com/cases'}
                  className="text-center mt-25 bg-purple hover:bg-green text-14 md:text-16 text-white flex justify-center items-center py-8  px-23 rounded-5 cursor-pointer"
                >
                  More Cases
                </a>
                <a
                  target="_blank"
                  className="md:flex cursor-pointer mt-15 bg-green hover:bg-purple text-16 md:text-16 text-white ml-15 flex items-center py-5 px-23 rounded-5"
                  onClick={() => {
                    setShowOrderModel(true);
                    document.documentElement.style.overflow = 'hidden';
                  }}
                >
                  Request a Proposal
                </a>
                <a
                  target="_blank"
                  className="flex md:hidden cursor-pointer mt-15 bg-green hover:bg-purple text-16 md:text-16 text-white justify-center items-center py-5 px-23 rounded-5"
                  href={'/paid-advertising-services/order-now?service=' + service}
                >
                  Request a Proposal
                </a>
              </div>
            </div>
          );
        })}
      </Slider>
      <GetOrderProposal
        currency={props.currency}
        id={'from-cases_studies'}
        country={props.country}
        show={showOrderModel}
        hide={hideOrderModal}
        service={service}
      />
    </>
  );
};
export default PPCManagementSLider;
